export const formatFieldToControlerName = {
  address1: 'address.street',
  city: 'address.city',
  state: 'address.state',
  zip: 'address.zip',
  country: 'address.country',
  firstName: 'personalInformation.firstname',
  lastName: 'personalInformation.lastname',
  dob: 'dateOfBirth',
  phone: 'contact.phone'
};
